<script>
import XxAreaSelect from '../../Select/AreaSelect.vue';
import XxDatepicker from './DatePicker';
import XxDcSelect from '../../Select/DcSelect';
import XxPoi from './poi';
import XxProductCategory from './ProductCategory';
import XxRadioGroup from '../../RadioGroup';
import XxSelect from '../../Select';
import XxSupplierSelect from '../../Select/SupplierSelect';
import XxDepartmentSelect from '../../Select/DepartmentSelect';
import XxStocktakeMode from './stocktakeMode';

import XxBudgetinfoSelect from '../../Select/BudgetinfoSelect';
import XxRegionPoiSelect from '../../Select/RegionPoiSelect';
import XxRegionSelect from '../../Select/RegionSelect';

export default {
    name: 'XxSearchTemplate',
    props: {
        tpl: {
            type: [String, Object],
            required: true
        },
        value: {
            required: true
        },

        attrs: {
            type: Object,
            required: false
        }
    },
    components: {
        XxAreaSelect,
        XxDatepicker,
        XxDcSelect,
        XxPoi,
        XxProductCategory,
        XxRadioGroup,
        XxSelect,
        XxSupplierSelect,
        XxDepartmentSelect,
        XxStocktakeMode,
        XxBudgetinfoSelect,
        XxRegionPoiSelect,
        XxRegionSelect
    },
    watch: {},
    created() {},
    methods: {
        input(value) {
            this.$emit('input', value);
        }
    },
    render(h) {
        return h(this.tpl, {
            props: {
                value: this.value,
                ...this.attrs // !!!为了避免某些属性作为组件的prop在渲染之后会被清理掉
            },
            attrs: this.attrs,
            on: {
                input: this.input,
                ...this.$listeners
            }
        });
    }
};
</script>
